import * as React from 'react';
import { ActionButton, Checkbox, ComboBox, IComboBox, IComboBoxOption, ISpinButtonStyles, MessageBar, MessageBarType, Position, SpinButton, Stack, TextField, Toggle } from '@fluentui/react';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';

 
interface IEventTypePropertiesViewProps {
    item: IEventType;

    isLoading: boolean;
    propertyChanged: (key: string, value: any) => void;
    valid: (value: boolean) => void;
    setIcon: (file: File) => void;
    setIconUrl: (url: any) => void;
    IconUrl: any;
}

const styles: Partial<ISpinButtonStyles> = { spinButtonWrapper: { width: 75 } };

export const EventTypePropertiesView: React.FunctionComponent<IEventTypePropertiesViewProps> = (props) => {

    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    const onChangeOrder = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("order", newValue);
            }
        }
    }

    const onTypeChanged =
        (ev?: React.FormEvent<IComboBox>, option?: IComboBoxOption) => {
            props.propertyChanged("type", option?.key as number)
        } 


    const validate = (item: IEventType) => {
        props.valid(true);
    }

    React.useEffect(() => {
        validate(props.item);
    }, [props.item])

   

    const fileButtonClick = () => {
        if (document) {
            document.getElementById('hiddenFileInput')?.click();
        }
    }

    const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target && event.target.files) {
            const files = event.target.files;
            const newaFiles: File[] = []
            if (event.target.files.length > 0) {
                props.setIconUrl(window.URL.createObjectURL(event.target.files[0]));
                props.setIcon(event.target.files[0]);
            }
        }
    }
 
    return (<Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
        <Toggle checked={props.item.showOnWeb} label="Zobrazovat na webu" defaultChecked onText="Ano" offText="Ne" onChange={(e, checked) => { props.propertyChanged("showOnWeb", checked ? checked : false); }} />       
        <TextField required id="name" key="name" label="Název" disabled={props.isLoading} value={props.item.name}
            onChange={propertyChanged} />

        <TextField id="description" key="description" multiline label="Popis" disabled={props.isLoading} value={props.item.description}
            onChange={propertyChanged} rows={8} />

        <TextField id="longDescription" key="longDescription" multiline label="Dlouhý popis" disabled={props.isLoading} value={props.item.longDescription}
            onChange={propertyChanged} rows={8} />
        
            <SpinButton
                id="minAge"
                key="minAge"
                label="Pořadí"
                value={props.item.order.toString()}
                min={0}
                max={100}
            step={1}
            labelPosition={Position.top}
                onChange={onChangeOrder}
                incrementButtonAriaLabel="Zvýší hodnotu o 1"
                decrementButtonAriaLabel="Sníží hodnotu o 1"
            styles={styles} />

        <ComboBox label="Typ akce" onChange={onTypeChanged} selectedKey={props.item.type} options={[{ key: 0, text: "Lekce" }, { key: 1, text: "Tábor" }, { key: 2, text: "Školení" }]} />

            <Stack horizontalAlign="center">
            <ActionButton iconProps={{
                iconName: "add"
            }} allowDisabledFocus checked={false} disabled={props.item.id===0} onClick={fileButtonClick}>
                Vyber soubor
            </ActionButton>
            {
                (props.item.id === 0 ? <MessageBar messageBarType={MessageBarType.info}>Nejprve prosím uložte typ události a po té přidejte obrázek</MessageBar>:null)
            }
            <input id="hiddenFileInput" type="file" onChange={onChange} style={{ display: "none" }} accept="image/png, image/gif, image/jpeg" />
             
                <img src={props.IconUrl} style={{ maxWidth: 200 }} onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "/img/noimageicon.png";
                }} />
           
        </Stack>
    </Stack>)
}